import React from "react";
import { Box, Typography, Button, Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { accountsmanagement } from "../../../config";
// *** NEW: Import router hooks to read ID from URL ***
import { useParams } from 'react-router-dom';

// NOTE: You need to create an array of columns that contains ONLY the fields you want to show.
import { allRelievers } from "../../../data/Columns/hrmanagement"; 

// *** FIX: Import 'allUsersQuery' to resolve the 'relieversQuery' error ***
// If you create a specific query later (e.g., allProformaRelieversQuery), update this.
import { allUsersQuery } from "../../../data/Axios/queries"; 
import ClientReceiptEntryForm from "./form";
import ClientReceiptLinesForm from "./ClientReceiptLinesForm";
import { ClientReceiptLinesColumns } from "../../../data/DynamicTable/Collumns";
import { useNavigate, useLocation } from "react-router-dom";

const base_url = accountsmanagement.uri;
function ClientReceiptLines() {
    const location = useLocation();
     const data = 
        location.state?.receiptData ||
        JSON.parse(localStorage.getItem("MyClientReceiptData"));
     const theme = useTheme();
     const colors = tokens(theme.palette.mode);
     const navigate = useNavigate();

     const handleGoBack = () => {
        const backPath = location.state?.from || "/client-receipts";
        navigate(backPath);
      };

// Define actions for a simple view-only relievers list (unchanged)
const actions = {
    entity: "Client Receipt Lines",
    required: "id",
    edit: {
        key: "EDIT",
        button_name: "Edit Client Receipt Lines",
        Show_Button: true, 
       permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    add: {
        key: "ADD",
        button_name: "Add Client Receipt Lines",
        Show_Button: true, 
        permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    showStatus: false,
    modelName: " receiptLines",
    showStatus: false,
    dataObject: {
      inputFields: {
        receiptId: data.id,
      },
      inputObjectName: "receiptLines",
      inputSubObjectName: "receiptLines",
      returnFields: [
        "id",
        "receiptId",
        "feeNoteLineId",
        "accountSubCategoryId",
        "accountSubCategoryName",
        "description",
        "amount",
        "isActive",
        "createdBy",
        "createdDate",
        "updatedBy",
        "updatedDate",
      ],
    },
  };



const title = `Client Receipt Lines`;

  const subtitle = `View All Lines`;

  return (
    <Box m="2px" p="1rem">
      {/* Floating Back Button */}
      <Fab
        color="secondary"
        aria-label="go back"
        onClick={handleGoBack}
        sx={{
          position: "fixed",
          top: 120,      
          left: 270,     
          zIndex: 1100,
          width: 40,
          height: 40,
          boxShadow: 3,
          "&:hover": {
          boxShadow: 6,
          },
        }}
      >
        <ArrowBackIcon />
      </Fab>
      
      <DynamicTable
        title={title}
        subtitle={subtitle}
        columns={ClientReceiptLinesColumns}
        FormComponent={ClientReceiptLinesForm}
        //query={allCasesView}
        base_url={base_url}
        actions={actions}
      />
      {/* //)} */}
    </Box>
  );


    
    

}
export default ClientReceiptLines;